import { useEffect, type ReactNode } from 'react';
import { InView } from 'react-intersection-observer';
import { NotificationStatus } from '@data/sdk/match';

interface DelayedInViewProps {
  children: ReactNode;
  delay: number;
  handleReadNotification: () => void;
  status: NotificationStatus;
  threshold?: number | number[];
}

export const DelayedInView = ({
  handleReadNotification,
  status,
  delay,
  children,
  ...rest
}: DelayedInViewProps) => {
  let timeoutRef: NodeJS.Timeout;

  const handleChange = (isVisible: boolean) => {
    clearTimeout(timeoutRef);

    if (isVisible && status === NotificationStatus.Unread) {
      timeoutRef = setTimeout(() => {
        handleReadNotification();
      }, delay);
    }
  };
  useEffect(() => {
    return () => {
      clearTimeout(timeoutRef);
    };
  }, []);

  return (
    <InView {...rest} onChange={handleChange}>
      {children}
    </InView>
  );
};
